import { combineReducers } from 'redux'
import loading from './loading'
import orderReducer from './orderReducer'
import homeReducer from './homeReducer'
import shopChangeReducer from './shopChangeReducer'

export default combineReducers({
  orderReducer,
  loading,
  homeReducer,
  shopChangeReducer
})